"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.HttpMethods = void 0;
var HttpMethods;
(function (HttpMethods) {
    HttpMethods["POST"] = "POST";
    HttpMethods["PUT"] = "PUT";
})(HttpMethods || (exports.HttpMethods = HttpMethods = {}));
const DefaultHeaders = {
    "Content-Type": "application/json",
};
function transformBody(body, headers) {
    if (headers["Content-Type"] === "application/json") {
        return JSON.stringify(body);
    }
    return body;
}
class HttpClient {
    static get(url, cache) {
        return fetch(url, { cache }).then((response) => {
            if (!response.ok) {
                return Promise.reject(response);
            }
            return response.json();
        });
    }
    static post(url, body, headers) {
        const requestHeaders = {
            ...DefaultHeaders,
            ...(headers || {}),
        };
        return fetch(url, {
            method: HttpMethods.POST,
            headers: requestHeaders,
            body: transformBody(body, requestHeaders),
        });
    }
    static put(url, body, headers) {
        const requestHeaders = {
            ...DefaultHeaders,
            ...(headers || {}),
        };
        return fetch(url, {
            method: HttpMethods.PUT,
            headers: requestHeaders,
            body: transformBody(body, requestHeaders),
        });
    }
}
exports.HttpClient = HttpClient;
